export const initTracker = (name, tracker) => {
  try {
    tracker.init()
  } catch (e) {
    console.warn(`Could not load tracker '${name}': ${e.message}`)
  }
}
